import styled, { keyframes } from "styled-components";

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const PageHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* margin-bottom: 1.5rem; */
`;

export const PageHeaderTitle = styled.span`
    color: #fff;
    font-family: "Lato", sans-serif;
    font-size: 36px;
    font-weight: 700;
    line-height: 1;
`;

export const Actions = styled.div`
    display: flex;
    gap: 0.75rem;
`;

export const ActionButton = styled.button`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    background-color: #1f2937;
    color: #d1d5db;
    border-radius: 0.5rem;
    transition: all 0.15s ease-in-out;

    &:hover {
        background-color: #374151;
    }
`;
